import type { Staff } from "~/models/Staff";
import type { VendorUser } from "./VendorUser";

export type DealUploadFile = {
	createdAt: string;
	dealId: number;
	fileName: string;
	id: number;
	optionalFilename: string | null;
	originalFilename: string | null;
	staff: Staff;
	vendorUser: VendorUser;
};

export type DealUploadFileUpdateParam = {
	id: number;
	optionalFilename: string | null;
};

export const canDestroy = (
	file: DealUploadFile,
	isVendor: boolean
): boolean => {
	// Adminで登録したファイルは常に削除できるようにする
	if (file.vendorUser === null && file.staff === null) return true;
	if (isVendor) {
		return file.vendorUser !== null;
	}
	return file.staff !== null;
};
